import FeaturedProducts from "../components/layout/Sections/FeaturedProducts"
import Hero from "../components/layout/Sections/Hero"
import WhyChooseUs from "../components/layout/Sections/WhyChooseUs"

const Home = () => {
    return(
        <>
            <Hero />
            <FeaturedProducts />
            <WhyChooseUs />
        </>
    )
}

export default Home